/**
 * Simple cache for entities to prevent excessive API calls
 */

interface CachedEntities {
  catalogs: any[];
  documents: any[];
  registers: any[];
  timestamp: number;
}

const CACHE_TTL = 30000; // 30 seconds
const cache: Map<string, CachedEntities> = new Map();

/** Sidebar uses `connectionId`; FK pickers need full list incl. exclude_from_sidebar — separate key. */
export function entitiesCacheKeyForReferencePickers(connectionId: string): string {
  return `${connectionId}:refs_full`;
}

export const entitiesCache = {
  get: (connectionId: string): CachedEntities | null => {
    const cached = cache.get(connectionId);
    if (!cached) {
      return null;
    }
    
    const age = Date.now() - cached.timestamp;
    if (age > CACHE_TTL) {
      cache.delete(connectionId);
      return null;
    }
    
    return cached;
  },
  
  set: (connectionId: string, entities: { catalogs?: any[]; documents?: any[]; registers?: any[] }): void => {
    cache.set(connectionId, {
      catalogs: entities.catalogs || [],
      documents: entities.documents || [],
      registers: entities.registers || [],
      timestamp: Date.now(),
    });
  },
  
  clear: (connectionId?: string): void => {
    if (connectionId) {
      cache.delete(connectionId);
      cache.delete(entitiesCacheKeyForReferencePickers(connectionId));
    } else {
      cache.clear();
    }
  },
};

